export default __webpack_public_path__ + "static/media/Google_Drive_icon.40465407.svg";